import * as ActionTypes from './types.action';

export function setRestaurantCodeSuccess(restaurantCode) {
  return {
    type: ActionTypes.SET_RESTAURANT_CODE_SUCCESS,
    restaurantCode
  };
}

export function setRestaurantCode(restaurantCode) {
  return function (dispatch) {
    return dispatch(setRestaurantCodeSuccess(restaurantCode));
  };
}



// WEBPACK FOOTER //
// ./actions/restaurant.action.js